import { render, staticRenderFns } from "./stationSelectInventoryBinDialog.vue?vue&type=template&id=63157f38&"
import script from "./stationSelectInventoryBinDialog.vue?vue&type=script&lang=js&"
export * from "./stationSelectInventoryBinDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports